<template>
  <section class="out-of-stock hide-for-large-up">
    <h5>{{ product.title }} is sold out.</h5>
    <p>
      Never miss out again: Sign up to receive notifications the instant wines
      from this producer go live!
    </p>
    <ProductNotifyMe :product="product" />
  </section>
</template>

<script>
import {
  requestedNotification,
  disableNotificationService,
} from '#common/utils/catalog'

export default {
  components: {
    ProductNotifyMe: defineAsyncComponent(
      () => import('@/components/Product/PDP/ProductNotifyMe'),
    ),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notifyMeModalOpen: false,
    }
  },
  computed: {
    notificationChecked() {
      return requestedNotification(this.$auth.user, this.product.product_id)
    },
    notifyClasses() {
      return {
        'notify-me': true,
        checked: this.notificationChecked,
      }
    },
  },
  methods: {
    async disableNotification() {
      await disableNotificationService(
        this.$axios,
        this.object.product_id,
        this.$auth.user,
      )
    },
  },
}
</script>
